import { Stack, Typography } from "@mui/material";
import { useProfileContext } from "../../../context/profileContext";

export default function UserAccountMobileComponent() {
  const { userProfile } = useProfileContext();

  return (
    <Stack
      width="100%"
      direction="row"
      justifyContent={{ xs: "space-between", sm: "space-around" }}
      alignItems="center"
      py="12px"
      px={{ md: "24px", xs: "4px" }}
      color={(theme) => theme.palette.others.bg}
      bgcolor={(theme) => theme.palette.dominant.main}
    >
      <Stack
        width="100%"
        direction="row"
        justifyContent="space-around"
        alignItems="center"
        gap="4px"
      >
        <Stack direction="row" alignItems="center">
          <img
            src="/images/user.svg"
            alt="profileImage"
            style={{ width: "20px", height: "20px" }}
          />
          <Typography
            variant="warningMediumBold"
            color={(theme) => theme.palette.others.bg}
          >
            {userProfile?.name}
          </Typography>
        </Stack>
        <Typography
          dir="ltr"
          color={(theme) => theme.palette.gray[100]}
          variant="warningRegular"
        >
          {userProfile?.mobile}
        </Typography>
      </Stack>
    </Stack>
  );
}
